import React from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "../lib/api";

export default function ListingCard({ listing, testid }) {
  const img = listing.images?.[0];
  const src = img ? (img.startsWith("http") ? img : fileUrl(img)) : null;
  return (
    <Link
      to={`/marketplace/${listing.id}`}
      data-testid={testid}
      className="group relative block bg-[#0a0a0a] border border-[var(--border-dim)] hover:border-[var(--accent)] transition-colors duration-300"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#050505]">
        {src ? (
          <img src={src} alt={listing.title} className="w-full h-full object-cover img-editorial group-hover:scale-105 transition-transform duration-700" />
        ) : (
          <div className="w-full h-full flex items-center justify-center font-mono text-xs text-[var(--text-secondary)]">NO IMAGE</div>
        )}
        {listing.status === "sold" && (
          <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
            <span className="font-display font-black uppercase text-3xl rotate-[-8deg] border-2 border-[var(--accent)] text-[var(--accent)] px-4 py-1">Sold</span>
          </div>
        )}
        <span className="absolute top-3 left-3 font-mono text-[10px] uppercase tracking-widest bg-[#050505]/80 px-2 py-1 border border-[var(--border-dim)]">{listing.category} · {listing.condition}</span>
      </div>
      <div className="p-4 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-display font-bold uppercase text-lg leading-tight group-hover:text-[var(--accent)] transition-colors">{listing.title}</h3>
        </div>
        <span className="font-mono text-lg whitespace-nowrap">${Number(listing.price).toLocaleString()}</span>
      </div>
    </Link>
  );
}
